$(function(){
  $('.js-load-more').on('click', function(){
    PaginationLoadNext();
  });
  
  $(window).on('resize scroll', function() {
    if ($('.js-load-more').length > 0) {
      if ($('.js-load-more').isInViewport()) {
        if (!$('.js-load-more').is('.loading')) {
          $('.js-load-more').addClass('loading');
          PaginationLoadNext();
        }
      }
    }
  });
  
  function PaginationLoadNext() {
    var $this = $('.js-load-more'), totalPages = parseInt($('[data-all-pages]').val()), currentPage = parseInt($('[data-this-page]').val()), datacollurl = $('[data-coll-url]').val();
    $this.attr('disabled', true);
    $this.find('[load-more-text]').addClass('hide');
    $this.find('[loader]').removeClass('hide');
    var nextUrl = $('[data-next-link]').val();
    var current_page_new = currentPage + 1;
    var next_coll = currentPage + 2;
    
    $.ajax({
      url: nextUrl,
      type: 'GET',
      dataType: 'html',
      success: function(responseHTML){
        $('[data-next-link]').val(datacollurl + "?page="+next_coll);
        $('[data-this-page]').val(current_page_new);
        $('.product-list').append($(responseHTML).find('.product-list').html());
        theme.initAnimateOnScroll();
        //theme.loadLazyBGSet($('.product-list'));
        theme.ProductBlockManager.loadImages();
      },
      complete: function() {
        if(current_page_new < totalPages) {
          $this.removeClass('loading');
          $this.attr('disabled', false);
          $this.find('[load-more-text]').removeClass('hide');
          $this.find('[loader]').addClass('hide');
        }
        if(current_page_new >= totalPages) {
          $this.addClass('off');
        }
      }
    });
  }

  /*var snapbackCache = SnapbackCache({
    bodySelector: "#AjaxinateLoop",
  });*/
});

function PaginationInit() {
  var $this = $('.js-load-more');
  $this.removeClass('off');
  $('[data-this-page]').val(1);
  $this.removeClass('loading');
  $this.attr('disabled', false);
  $this.find('[load-more-text]').removeClass('hide');
  $this.find('[loader]').addClass('hide');
}

$.fn.isInViewport = function() {
  var elementTop = $(this).offset().top;
  var elementBottom = elementTop + $(this).outerHeight();
  
  var viewportTop = $(window).scrollTop();
  var viewportBottom = viewportTop + $(window).height();
  
  return elementBottom > viewportTop && elementTop < viewportBottom;
};
